import firebase from 'firebase'

var firebaseConfig = {
    apiKey: "AIzaSyDPrSJkYxCkb-ILHHZLNU38byg_nM18-IA",
    authDomain: "am-beats-2.firebaseapp.com",
    projectId: "am-beats-2",
    storageBucket: "am-beats-2.appspot.com",
    messagingSenderId: "72980654732",
    appId: "1:72980654732:web:abb09831ccc5a26f93e9a9"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  const firestore=firebase.firestore()
  const storage=firebase.storage()
  const timeStamp=firebase.firestore.FieldValue.serverTimestamp

  //other const 

  const userPhone=localStorage.getItem('user-phone')
  const userName=localStorage.getItem('user-name')

  export {firestore,storage,timeStamp ,userPhone,userName}